import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { FaHotel } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ErpTemplate from '../../components/ErpTemplate';
import { FinField, FinInput, FinTextarea } from '../../components/FinField';
import ReactSelect from '../../components/ReactSelect';
import api from '../../services/api';
import { buscarCep, extract } from '../../util/util';
import '../../css/financeiro-parcela-pagar.css';

const OPCOES_SITUACAO = [
    { value: 'ativo', label: 'Ativo' },
    { value: 'inativo', label: 'Inativo' },
];

const OPCOES_SIM_NAO = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
];

const OPCOES_INDICADOR_INSCRICAO = [
    { value: '1', label: 'Contribuinte' },
    { value: '2', label: 'Isento' },
    { value: '9', label: 'Não contribuinte' },
];

const OPCOES_REGIME_TRIBUTARIO = [
    { value: '1', label: 'MEI' },
    { value: '2', label: 'Simples Nacional' },
    { value: '3', label: 'Simples Nacional (Sublimite)' },
    { value: '4', label: 'Lucro Presumido' },
];

export default function CadastroHotel({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const history = useHistory();
    const [tabState, setTabState] = useState('geral');
    const [dados, setDados] = useState({ tipoCadastro: 'hotel', situacaoRegistro: 'ativo' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);

    const preencherCep = (cep, dadosAtuais) => {
        buscarCep(cep).then((resposta) => {
            if (resposta.erro) {
                return;
            }
            setDados({
                ...dadosAtuais,
                enderecobairro: resposta.bairro,
                enderecocomplemento: resposta.complemento,
                enderecologradouro: resposta.logradouro,
                enderecopais: '30',
                nomeEnderecopais: 'Brasil',
                enderecomunicipio: resposta.ibge,
                nomeEnderecomunicipio: resposta.localidade
            });
        });
    };

    const buscar = () => {
        setIsLoading(true);
        if (!id) {
            setDados((state) => ({ ...state, tipoCadastro: 'hotel' }));
            setIsLoading(false);
            return;
        }
        api({
            method: 'get',
            action: `/participante/${id}`,
            token,
        }).then((response) => {
            const dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: ['enderecopais', 'aereomunicipioembarque', 'enderecomunicipio', 'banco', 'categoria']
            });
            delete dadosRecebidos.tipoparticipante;
            setDados({
                ...dadosRecebidos,
                tipoCadastro: 'hotel',
            });
        }).catch(() => { }).finally(() => setIsLoading(false));
    };

    const validar = () => {
        if (!String(dados.nome ?? '').trim()) {
            toast.error('É necessário preencher o nome');
            setTabState('geral');
            setTimeout(() => document.querySelector('#nome')?.focus(), 150);
            return false;
        }
        if (!String(dados.cnpj ?? '').trim() && !String(dados.cpf ?? '').trim()) {
            toast.error('É necessário preencher o CNPJ ou o CPF');
            setTabState('fiscal');
            setTimeout(() => document.querySelector('#cnpj')?.focus(), 150);
            return false;
        }
        return true;
    };

    const salvar = () => {
        if (isSubmitting || !validar()) {
            return;
        }
        setIsSubmitting(true);
        const requisicao = id
            ? { method: 'put', action: `/participante/${id}` }
            : { method: 'post', action: '/participante' };

        api({
            ...requisicao,
            token,
            data: dados,
        })
            .then(() => {
                toast.success('Dados salvos com sucesso!');
                history.push('/hotel');
            })
            .catch((error) => {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => setIsSubmitting(false));
    };

    useEffect(() => {
        document.querySelector('#nome')?.focus();
        buscar();
        // eslint-disable-next-line
    }, []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Hotel</h1>
                        <p className="fin-pp__subtitle">{dados.nome || 'Novo hotel'}</p>
                    </div>
                    <div className="fin-pp__actions">
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill" onClick={salvar} disabled={isSubmitting}>
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </button>
                    </div>
                </div>

                <form className="form" noValidate onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__tabs mb-3">
                        {[
                            { key: 'geral', label: 'Geral' },
                            { key: 'endereco', label: 'Endereço' },
                            { key: 'fiscal', label: 'Fiscal' },
                            { key: 'banco', label: 'Banco' },
                        ].map((item) => (
                            <button
                                key={item.key}
                                type="button"
                                className={'fin-pp__tab' + (tabState === item.key ? ' is-active' : '')}
                                onClick={() => setTabState(item.key)}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>

                    {tabState === 'geral' && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead">
                                <span className="fin-pp__cphead-ic"><FaHotel size={15} /></span>
                                <span className="fin-pp__cphead-title">Dados gerais</span>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Situação">
                                    <ReactSelect
                                        value={dados.situacaoRegistro ? OPCOES_SITUACAO.find((item) => item.value === dados.situacaoRegistro) ?? null : null}
                                        onChange={(e) => setDados({ ...dados, situacaoRegistro: e?.value ?? '' })}
                                        options={OPCOES_SITUACAO}
                                    />
                                </FinField>
                                <FinField label="Código">
                                    <FinInput id="codigo" value={dados.codigo ?? ''} onChange={(e) => setDados({ ...dados, codigo: e.target.value })} />
                                </FinField>
                                <FinField label="Categoria">
                                    <ReactSelect
                                        value={dados.categoria ? { value: dados.categoria, label: dados.nomeCategoria } : null}
                                        onChange={(e) => setDados({ ...dados, categoria: e?.value ?? null, nomeCategoria: e?.label ?? '' })}
                                        loadOptions={(input) => api({
                                            method: 'get',
                                            action: '/participanteCategoria',
                                            token,
                                            params: { nome: input }
                                        }).then((response) => (response.data.data ?? []).map((registro) => ({ value: registro.id, label: registro.nome }))).catch(() => [])}
                                    />
                                </FinField>
                                <FinField label="Preferencial">
                                    <ReactSelect
                                        value={dados.preferencial ? OPCOES_SIM_NAO.find((item) => item.value === dados.preferencial) ?? null : null}
                                        onChange={(e) => setDados({ ...dados, preferencial: e?.value ?? '' })}
                                        options={OPCOES_SIM_NAO}
                                    />
                                </FinField>
                                <FinField label="Pagamento Antecipado">
                                    <ReactSelect
                                        value={dados.pagamentoantecipado ? OPCOES_SIM_NAO.find((item) => item.value === dados.pagamentoantecipado) ?? null : null}
                                        onChange={(e) => setDados({ ...dados, pagamentoantecipado: e?.value ?? '' })}
                                        options={OPCOES_SIM_NAO}
                                    />
                                </FinField>
                                <FinField label="Nome" full>
                                    <FinInput id="nome" value={dados.nome ?? ''} onChange={(e) => setDados({ ...dados, nome: e.target.value })} />
                                </FinField>
                                <FinField label="Contato">
                                    <FinInput value={dados.contato ?? ''} onChange={(e) => setDados({ ...dados, contato: e.target.value })} />
                                </FinField>
                                <FinField label="Telefone">
                                    <FinInput value={dados.telefone ?? ''} onChange={(e) => setDados({ ...dados, telefone: e.target.value })} />
                                </FinField>
                                <FinField label="Celular">
                                    <InputMask
                                        mask="(99) 99999-9999"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        value={dados.celular ?? ''}
                                        onChange={(e) => setDados({ ...dados, celular: e.target.value })}
                                    />
                                </FinField>
                                <FinField label="E-mail" full>
                                    <FinInput value={dados.email ?? ''} onChange={(e) => setDados({ ...dados, email: e.target.value })} />
                                </FinField>
                                <FinField label="Observações" full>
                                    <FinTextarea id="observacao" value={dados.observacao ?? ''} onChange={(e) => setDados({ ...dados, observacao: e.target.value })} />
                                </FinField>
                            </div>
                        </div>
                    )}

                    {tabState === 'endereco' && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead">
                                <span className="fin-pp__cphead-title">Endereço</span>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Rua / Logradouro" grow>
                                    <FinInput value={dados.enderecologradouro ?? ''} onChange={(e) => setDados({ ...dados, enderecologradouro: e.target.value })} />
                                </FinField>
                                <FinField label="Número">
                                    <FinInput value={dados.endereconumero ?? ''} onChange={(e) => setDados({ ...dados, endereconumero: e.target.value })} />
                                </FinField>
                                <FinField label="Complemento" grow>
                                    <FinInput value={dados.enderecocomplemento ?? ''} onChange={(e) => setDados({ ...dados, enderecocomplemento: e.target.value })} />
                                </FinField>
                                <FinField label="CEP">
                                    <InputMask
                                        mask="99999-999"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        value={dados.enderecocep ?? ''}
                                        onChange={(e) => {
                                            const proximo = { ...dados, enderecocep: e.target.value };
                                            setDados(proximo);
                                            if ((e.target.value ?? '').replace(/\D/g, '').length === 8) {
                                                preencherCep(e.target.value, proximo);
                                            }
                                        }}
                                    />
                                </FinField>
                                <FinField label="Bairro">
                                    <FinInput value={dados.enderecobairro ?? ''} onChange={(e) => setDados({ ...dados, enderecobairro: e.target.value })} />
                                </FinField>
                                <FinField label="Cidade">
                                    <ReactSelect
                                        value={dados.enderecomunicipio ? { value: dados.enderecomunicipio, label: dados.nomeEnderecomunicipio } : null}
                                        onChange={(e) => setDados({ ...dados, enderecomunicipio: e?.value ?? null, nomeEnderecomunicipio: e?.label ?? '' })}
                                        loadOptions={(input) => api({
                                            method: 'get',
                                            action: '/municipio',
                                            token,
                                            params: { nome: input }
                                        }).then((response) => (response.data.data ?? []).map((registro) => ({ value: registro.id, label: `${registro.nome}-${registro.uf}` }))).catch(() => [])}
                                    />
                                </FinField>
                                <FinField label="País">
                                    <ReactSelect
                                        value={dados.enderecopais ? { value: dados.enderecopais, label: dados.nomeEnderecopais } : null}
                                        onChange={(e) => setDados({ ...dados, enderecopais: e?.value ?? null, nomeEnderecopais: e?.label ?? '' })}
                                        loadOptions={(input) => api({
                                            method: 'get',
                                            action: '/pais',
                                            token,
                                            params: { nome: input }
                                        }).then((response) => (response.data.data ?? []).map((registro) => ({ value: registro.id, label: registro.nome }))).catch(() => [])}
                                    />
                                </FinField>
                            </div>
                        </div>
                    )}

                    {tabState === 'fiscal' && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead">
                                <span className="fin-pp__cphead-title">Dados fiscais</span>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="CNPJ">
                                    <FinInput id="cnpj" value={dados.cnpj ?? ''} onChange={(e) => setDados({ ...dados, cnpj: e.target.value })} />
                                </FinField>
                                <FinField label="CPF">
                                    <FinInput id="cpf" value={dados.cpf ?? ''} onChange={(e) => setDados({ ...dados, cpf: e.target.value })} />
                                </FinField>
                                <FinField label="Inscrição Estadual">
                                    <FinInput value={dados.inscricaoestadual ?? ''} onChange={(e) => setDados({ ...dados, inscricaoestadual: e.target.value })} />
                                </FinField>
                                <FinField label="Indicador de Inscrição">
                                    <ReactSelect
                                        value={dados.indicadorinscricao ? OPCOES_INDICADOR_INSCRICAO.find((item) => item.value === dados.indicadorinscricao) ?? null : null}
                                        onChange={(e) => setDados({ ...dados, indicadorinscricao: e?.value ?? '' })}
                                        options={OPCOES_INDICADOR_INSCRICAO}
                                    />
                                </FinField>
                                <FinField label="Inscrição Municipal">
                                    <FinInput value={dados.inscricaomunicipal ?? ''} onChange={(e) => setDados({ ...dados, inscricaomunicipal: e.target.value })} />
                                </FinField>
                                <FinField label="Regime Tributário">
                                    <ReactSelect
                                        value={dados.regimetributario ? OPCOES_REGIME_TRIBUTARIO.find((item) => item.value === dados.regimetributario) ?? null : null}
                                        onChange={(e) => setDados({ ...dados, regimetributario: e?.value ?? '' })}
                                        options={OPCOES_REGIME_TRIBUTARIO}
                                    />
                                </FinField>
                                <FinField label="RG">
                                    <FinInput value={dados.rg ?? ''} onChange={(e) => setDados({ ...dados, rg: e.target.value })} />
                                </FinField>
                                <FinField label="Nome Fantasia">
                                    <FinInput value={dados.nomefantasia ?? ''} onChange={(e) => setDados({ ...dados, nomefantasia: e.target.value })} />
                                </FinField>
                            </div>
                        </div>
                    )}

                    {tabState === 'banco' && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead">
                                <span className="fin-pp__cphead-title">Dados bancários</span>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Banco">
                                    <ReactSelect
                                        value={dados.banco ? { value: dados.banco, label: dados.nomeBanco } : null}
                                        onChange={(e) => setDados({ ...dados, banco: e?.value ?? null, nomeBanco: e?.label ?? '' })}
                                        loadOptions={(input) => api({
                                            method: 'get',
                                            action: '/financeiroBanco',
                                            token,
                                            params: { nome: input }
                                        }).then((response) => (response.data.data ?? []).map((registro) => ({ value: registro.id, label: `${registro.codigo} - ${registro.nome}` }))).catch(() => [])}
                                    />
                                </FinField>
                                <FinField label="Agência">
                                    <FinInput value={dados.bancoagencia ?? ''} onChange={(e) => setDados({ ...dados, bancoagencia: e.target.value })} />
                                </FinField>
                                <FinField label="Conta">
                                    <FinInput value={dados.bancoconta ?? ''} onChange={(e) => setDados({ ...dados, bancoconta: e.target.value })} />
                                </FinField>
                            </div>
                        </div>
                    )}
                </form>
            </div>
        </ErpTemplate>
    );
}
